import { JournalPage } from "components/frontComponents/journalPage/JournalPage";
import gsap from "gsap";
import styles from "./styles.module.scss";
import Left from "assets/images/features/featuresLeft.png";
import Right from "assets/images/features/featuresRight.png";
import Black from "assets/images/features/black.png";

import Yellow from "assets/images/features/yellow.png";
import YellowLeft from "assets/images/features/yellowLeft.png";
import White from "assets/images/features/white.png";
import Pink from "assets/images/features/pink.png";
import PinkLeft from "assets/images/features/pinkLeft.png";
import { useEffect, useRef } from "react";
import { ScrollPageProps } from "../FirstPage";

export const Features: React.FC<ScrollPageProps> = ({
  scrollToRef,
  aboutRef,
  mainRef,
  featuresRef,
  contactsRef,
  activeSection,
}) => {
  const yellowRef = useRef(null);
  const yellowLeftRef = useRef(null);
  const blackRef = useRef(null);

  const pinkLeftRef = useRef(null);
  const pinkRef = useRef(null);
  const whiteRef = useRef(null);
  useEffect(() => {
    gsap.to(
      [
        yellowRef.current,
        yellowLeftRef.current,
        blackRef.current,

        pinkLeftRef.current,
        pinkRef.current,
        whiteRef.current,
      ],
      {
        duration: 2,
        scale: 1.1,
        ease: "power2.inOut",
        repeat: -1,
        yoyo: true,
      }
    );
  }, []);
  return (
    <div className={styles.about} id="components">
      <JournalPage
        aboutRef={aboutRef}
        mainRef={mainRef}
        featuresRef={featuresRef}
        contactsRef={contactsRef}
        scrollToRef={scrollToRef}
        activeSection={activeSection}
        leftContent={
          <div className={styles.containerLeft}>
            <div className={styles.photoholder}>
              <img
                src={Left}
                alt=""
                loading="lazy"
                className={styles.photoleft}
              />
            </div>
            {/* <picture>
              <source media="(min-width: 1920px)" srcSet={Left} />
              <source media="(min-width: 1025px)" srcSet={Left1440} />
              <source media="(min-width: 1000px)" srcSet={Left768} />              
              <img src={Left768} alt="" loading="lazy" />
            </picture> */}
            <div className={styles.yellowleftholder}>
              <img
                src={YellowLeft}
                className={styles.yellowLeft}
                ref={yellowLeftRef}
                alt=""
              />
            </div>

            <div className={styles.pinkleftholder}>
              <img
                src={PinkLeft}
                className={styles.pinkLeft}
                ref={pinkLeftRef}
                alt=""
              />
            </div>
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            {/* <picture>
              <source media="(min-width: 1920px)" srcSet={Right} />
              <source media="(min-width: 769px)" srcSet={Right1440} />
              <img src={Right768} alt="" loading="lazy" />
            </picture> */}
            <div className={styles.photoholder}>
              <img
                src={Right}
                alt=""
                loading="lazy"
                className={styles.photoright}
              />
            </div>
            <div className={styles.yellowholder}>
              <img
                src={Yellow}
                className={styles.yellow}
                ref={yellowRef}
                alt=""
              />
            </div>
            <div className={styles.pinkholder}>
              <img src={Pink} className={styles.pink} ref={pinkRef} alt="" />
            </div>
            <div className={styles.whiteholder}>
              <img src={White} className={styles.white} ref={whiteRef} alt="" />
            </div>
          </div>
        }
      />
    </div>
  );
};
